import SubcategoryPage from '@/components/template/SubcategoryPage';

const StekleniDodatki = () => {
  const products = [
    {
      title: "Steklena vaza Clara",
      imageSrc: "https://images.unsplash.com/photo-1583845112239-97ef1341b271?auto=format&fit=crop&q=80",
      url: "/dodatki/stekleni/clara"
    },
    {
      title: "Stekleni podstavki Lumina",
      imageSrc: "https://images.unsplash.com/photo-1612033448550-9d6f9c17f07d?auto=format&fit=crop&q=80",
      url: "/dodatki/stekleni/lumina"
    },
    {
      title: "Steklena posoda Aria",
      imageSrc: "https://images.unsplash.com/photo-1615301887608-8935d569afe8?auto=format&fit=crop&q=80",
      url: "/dodatki/stekleni/aria"
    },
    {
      title: "Stekleni svečniki Crystalo",
      imageSrc: "https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?auto=format&fit=crop&q=80",
      url: "/dodatki/stekleni/crystalo"
    }
  ];

  return (
    <SubcategoryPage
      title="Stekleni dodatki"
      description="Elegantni stekleni dodatki, ki s svojo prosojnostjo in igro svetlobe ustvarjajo čarobno vzdušje v vašem domu."
      heroImage="https://images.unsplash.com/photo-1583845112239-97ef1341b271?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default StekleniDodatki;